import { decodeJwt, type SupabaseJwt } from "@mixitone/util";
import { MFA_SESSION_MAX_AGE_SECONDS } from "./mfaSessionTypes";

type JwtLike = Pick<SupabaseJwt, "aal" | "amr"> & { deviceToken?: string };

export function latestTotpAmrTimestamp(jwt: JwtLike): number | null {
  const amr = jwt.amr;
  if (!Array.isArray(amr)) return null;
  let latest: number | null = null;
  for (const entry of amr) {
    if (entry?.method !== "totp") continue;
    const ts = typeof entry.timestamp === "number" ? entry.timestamp : Number(entry.timestamp);
    if (!Number.isFinite(ts)) continue;
    if (latest === null || ts > latest) latest = ts;
  }
  return latest;
}

export function hasRecentMfaSession(
  jwt: JwtLike | null | undefined,
  maxAgeSeconds: number = MFA_SESSION_MAX_AGE_SECONDS,
  nowSeconds: number = Math.floor(Date.now() / 1000),
): boolean {
  if (jwt?.aal !== "aal2") return false;
  const totpAt = latestTotpAmrTimestamp(jwt);
  if (totpAt === null) return false;
  return nowSeconds - totpAt <= maxAgeSeconds;
}

export function decodeAccessToken(accessToken: string | null | undefined): JwtLike | null {
  if (!accessToken) return null;
  try {
    return decodeJwt(accessToken) as JwtLike;
  } catch {
    return null;
  }
}

export function jwtHasDeviceToken(jwt: JwtLike | null | undefined): boolean {
  return typeof jwt?.deviceToken === "string" && jwt.deviceToken.length > 0;
}
